module.exports = __webpack_public_path__ + "img/11_noff_open_L3.a65d5c2d.svg";